// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".end-message[data-v-0343c8a2]{margin:0 !important;margin-top:1.25rem !important;margin-bottom:1.25rem !important;text-align:center !important;font-size:0.75rem !important;line-height:1rem !important;line-height:18px}.end-message.alt[data-v-0343c8a2]{margin-top:0 !important;margin-bottom:0 !important;font-size:1rem !important;line-height:1.5rem !important}.end-message[data-v-0343c8a2],.end-message a[data-v-0343c8a2]{color:rgba(0,0,0,.6)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
